/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Staatsexamen_Jura20Inputs */

const en__field_enum_tuda_staatsexamen_jura20 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Jura20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

const de__field_enum_tuda_staatsexamen_jura20 = /** @type {(inputs: _Field_Enum_Tuda_Staatsexamen_Jura20Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen Jura`)
};

/**
* | output |
* | --- |
* | "Staatsexamen Jura" |
*
* @param {_Field_Enum_Tuda_Staatsexamen_Jura20Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_staatsexamen_jura20 = /** @type {((inputs?: _Field_Enum_Tuda_Staatsexamen_Jura20Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Staatsexamen_Jura20Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_staatsexamen_jura20(inputs)
	return de__field_enum_tuda_staatsexamen_jura20(inputs)
});
export { _field_enum_tuda_staatsexamen_jura20 as "_field_enum_TUDA_STAATSEXAMEN_JURA" }